// DO NOT EDIT -- generated from fs/services/llm-tool/schema-assistant.proto

import * as protobuf from '../../../google/protobuf';

/** A segment defines a cohort of users who have performed certain actions */
export interface Segment {
  eventFilters: EventFilter[];
  userFilters: UserFilter[];
}

/** A metric provides counts for the specified interactions */
export interface Metric {
  eventFilter: EventFilter | null;
  /** Which segment(s) used for comparison. Independent results would be returned for comparison. At least 1 is required */
  segments: Segment[];
  /** Group results by top results of the specified field */
  dimension: Dimension;
  aggregation: Aggregation;
}

/** A Funnel provides per-step counts for series of events that lead to users completing a task, such as completing a purchase */
export interface Funnel {
  eventFilters: EventFilter[];
  /** Which segment(s) used for comparison. Independent results would be returned for comparison. At least 1 is required */
  segments: Segment[];
  /** Group results by top results of the specified field */
  dimension: Dimension;
}

/** A UserFilter allows you to find users according to the specified criteria. Exactly one field should be populated when this is used */
export interface UserFilter {
  email?: StringOperator | null;
  name?: StringOperator | null;
  /** Finds users by the total amount of time they have been active on your site. */
  totalActiveTime?: DurationOperator | null;
  /** Finds users by the total amount of time they have spent on your site, including time in which they were inactive. */
  totalTime?: DurationOperator | null;
  /** Finds users by the average amount of time a user is active on your site during a session. */
  averageSessionActiveTime?: DurationOperator | null;
  averageSessionLength?: DurationOperator | null;
  firstSeen?: DateOperator | null;
  lastSeen?: DateOperator | null;
  totalSessions?: NumericOperator | null;
}

/** A UserFilter allows you to find users according to the specified criteria. Exactly one field should be populated when this is used */
export namespace UserFilter {
  export enum filter {
    email = 1,
    name = 2,
    /** Finds users by the total amount of time they have been active on your site. */
    totalActiveTime = 3,
    /** Finds users by the total amount of time they have spent on your site, including time in which they were inactive. */
    totalTime = 4,
    /** Finds users by the average amount of time a user is active on your site during a session. */
    averageSessionActiveTime = 5,
    averageSessionLength = 6,
    firstSeen = 7,
    lastSeen = 8,
    totalSessions = 9
  }

  export function filter_oneof(m: UserFilter): { opt: filter.averageSessionActiveTime, val: DurationOperator } | { opt: filter.averageSessionLength, val: DurationOperator } | { opt: filter.email, val: StringOperator } | { opt: filter.firstSeen, val: DateOperator } | { opt: filter.lastSeen, val: DateOperator } | { opt: filter.name, val: StringOperator } | { opt: filter.totalActiveTime, val: DurationOperator } | { opt: filter.totalSessions, val: NumericOperator } | { opt: filter.totalTime, val: DurationOperator } | null {
    if (m.email != null) { return { opt: filter.email, val: m.email } }
    if (m.name != null) { return { opt: filter.name, val: m.name } }
    if (m.totalActiveTime != null) { return { opt: filter.totalActiveTime, val: m.totalActiveTime } }
    if (m.totalTime != null) { return { opt: filter.totalTime, val: m.totalTime } }
    if (m.averageSessionActiveTime != null) { return { opt: filter.averageSessionActiveTime, val: m.averageSessionActiveTime } }
    if (m.averageSessionLength != null) { return { opt: filter.averageSessionLength, val: m.averageSessionLength } }
    if (m.firstSeen != null) { return { opt: filter.firstSeen, val: m.firstSeen } }
    if (m.lastSeen != null) { return { opt: filter.lastSeen, val: m.lastSeen } }
    if (m.totalSessions != null) { return { opt: filter.totalSessions, val: m.totalSessions } }
    return null;
  }
}

export interface EventFilter {
  primary: PrimaryEventFilter | null;
  deps: DependentEventFilter[];
}

/** A PrimaryEventFilter scopes to the specified interaction. Exactly one field should be populated when this is used */
export interface PrimaryEventFilter {
  visitedUrl?: UrlOperator | null;
  /** Finds activities where an Network error occurred. */
  ajaxErrorUrl?: UrlOperator | null;
  pageRefresh?: UrlOperator | null;
  click?: StringOperator | null;
  change?: StringOperator | null;
  rageClick?: StringOperator | null;
  errorClick?: StringOperator | null;
  deadClick?: StringOperator | null;
  /** finds activities where an element rendered on the page */
  seen?: StringOperator | null;
  uncaughtException?: StringOperator | null;
  highlight?: StringOperator | null;
  copy?: StringOperator | null;
  paste?: StringOperator | null;
  consoleError?: StringOperator | null;
  /** Finds activities with a specific First Contentful Paint time. */
  firstMeaningfulPaint?: DurationOperator | null;
  /** Finds activities with a specific page load time. */
  pageLoad?: DurationOperator | null;
  domContentLoaded?: DurationOperator | null;
  pinchGesture?: NoneOperator | null;
  firstInputDelay?: DurationOperator | null;
  largestContentfulPaint?: DurationOperator | null;
}

/** A PrimaryEventFilter scopes to the specified interaction. Exactly one field should be populated when this is used */
export namespace PrimaryEventFilter {
  export enum filter {
    visitedUrl = 1,
    /** Finds activities where an Network error occurred. */
    ajaxErrorUrl = 2,
    pageRefresh = 3,
    click = 4,
    change = 5,
    rageClick = 6,
    errorClick = 7,
    deadClick = 8,
    /** finds activities where an element rendered on the page */
    seen = 9,
    uncaughtException = 10,
    highlight = 11,
    copy = 12,
    paste = 13,
    consoleError = 14,
    /** Finds activities with a specific First Contentful Paint time. */
    firstMeaningfulPaint = 15,
    /** Finds activities with a specific page load time. */
    pageLoad = 16,
    domContentLoaded = 17,
    pinchGesture = 18,
    firstInputDelay = 19,
    largestContentfulPaint = 20
  }

  export function filter_oneof(m: PrimaryEventFilter): { opt: filter.ajaxErrorUrl, val: UrlOperator } | { opt: filter.change, val: StringOperator } | { opt: filter.click, val: StringOperator } | { opt: filter.consoleError, val: StringOperator } | { opt: filter.copy, val: StringOperator } | { opt: filter.deadClick, val: StringOperator } | { opt: filter.domContentLoaded, val: DurationOperator } | { opt: filter.errorClick, val: StringOperator } | { opt: filter.firstInputDelay, val: DurationOperator } | { opt: filter.firstMeaningfulPaint, val: DurationOperator } | { opt: filter.highlight, val: StringOperator } | { opt: filter.largestContentfulPaint, val: DurationOperator } | { opt: filter.pageLoad, val: DurationOperator } | { opt: filter.pageRefresh, val: UrlOperator } | { opt: filter.paste, val: StringOperator } | { opt: filter.pinchGesture, val: NoneOperator } | { opt: filter.rageClick, val: StringOperator } | { opt: filter.seen, val: StringOperator } | { opt: filter.uncaughtException, val: StringOperator } | { opt: filter.visitedUrl, val: UrlOperator } | null {
    if (m.visitedUrl != null) { return { opt: filter.visitedUrl, val: m.visitedUrl } }
    if (m.ajaxErrorUrl != null) { return { opt: filter.ajaxErrorUrl, val: m.ajaxErrorUrl } }
    if (m.pageRefresh != null) { return { opt: filter.pageRefresh, val: m.pageRefresh } }
    if (m.click != null) { return { opt: filter.click, val: m.click } }
    if (m.change != null) { return { opt: filter.change, val: m.change } }
    if (m.rageClick != null) { return { opt: filter.rageClick, val: m.rageClick } }
    if (m.errorClick != null) { return { opt: filter.errorClick, val: m.errorClick } }
    if (m.deadClick != null) { return { opt: filter.deadClick, val: m.deadClick } }
    if (m.seen != null) { return { opt: filter.seen, val: m.seen } }
    if (m.uncaughtException != null) { return { opt: filter.uncaughtException, val: m.uncaughtException } }
    if (m.highlight != null) { return { opt: filter.highlight, val: m.highlight } }
    if (m.copy != null) { return { opt: filter.copy, val: m.copy } }
    if (m.paste != null) { return { opt: filter.paste, val: m.paste } }
    if (m.consoleError != null) { return { opt: filter.consoleError, val: m.consoleError } }
    if (m.firstMeaningfulPaint != null) { return { opt: filter.firstMeaningfulPaint, val: m.firstMeaningfulPaint } }
    if (m.pageLoad != null) { return { opt: filter.pageLoad, val: m.pageLoad } }
    if (m.domContentLoaded != null) { return { opt: filter.domContentLoaded, val: m.domContentLoaded } }
    if (m.pinchGesture != null) { return { opt: filter.pinchGesture, val: m.pinchGesture } }
    if (m.firstInputDelay != null) { return { opt: filter.firstInputDelay, val: m.firstInputDelay } }
    if (m.largestContentfulPaint != null) { return { opt: filter.largestContentfulPaint, val: m.largestContentfulPaint } }
    return null;
  }
}

/** A DependentEventFilter criteria allows you to search for events when additional criteria is true. Exactly one field should be populated when this is used */
export interface DependentEventFilter {
  url?: UrlOperator | null;
  referrerUrl?: UrlOperator | null;
  city?: StringOperator | null;
  region?: StringOperator | null;
  country?: StringOperator | null;
  email?: StringOperator | null;
  name?: StringOperator | null;
  text?: StringOperator | null;
  browser?: BrowserOperator | null;
  pageDuration?: DurationOperator | null;
  /** Refines your search by the total time a user was active on a page where the event occurred. */
  pageActiveDuration?: DurationOperator | null;
  /** Refines your search by the time elapsed since page load. */
  timeSincePageLoad?: DurationOperator | null;
  timeSinceSessionStart?: DurationOperator | null;
  /** Refines your search by the number of console errors on the page. */
  consoleErrorsOnPage?: NumericOperator | null;
  consoleWarningsOnPage?: NumericOperator | null;
  displayWidth?: NumericOperator | null;
  displayHeight?: NumericOperator | null;
  /** Refines your search by the page the user started their session on. */
  sessionEntryPage?: BoolOperator | null;
  sessionExitPage?: BoolOperator | null;
}

/** A DependentEventFilter criteria allows you to search for events when additional criteria is true. Exactly one field should be populated when this is used */
export namespace DependentEventFilter {
  export enum filter {
    url = 1,
    referrerUrl = 2,
    city = 3,
    region = 4,
    country = 5,
    email = 6,
    name = 7,
    text = 8,
    browser = 9,
    pageDuration = 10,
    /** Refines your search by the total time a user was active on a page where the event occurred. */
    pageActiveDuration = 11,
    /** Refines your search by the time elapsed since page load. */
    timeSincePageLoad = 12,
    timeSinceSessionStart = 13,
    /** Refines your search by the number of console errors on the page. */
    consoleErrorsOnPage = 14,
    consoleWarningsOnPage = 15,
    displayWidth = 16,
    displayHeight = 17,
    /** Refines your search by the page the user started their session on. */
    sessionEntryPage = 18,
    sessionExitPage = 19
  }

  export function filter_oneof(m: DependentEventFilter): { opt: filter.browser, val: BrowserOperator } | { opt: filter.city, val: StringOperator } | { opt: filter.consoleErrorsOnPage, val: NumericOperator } | { opt: filter.consoleWarningsOnPage, val: NumericOperator } | { opt: filter.country, val: StringOperator } | { opt: filter.displayHeight, val: NumericOperator } | { opt: filter.displayWidth, val: NumericOperator } | { opt: filter.email, val: StringOperator } | { opt: filter.name, val: StringOperator } | { opt: filter.pageActiveDuration, val: DurationOperator } | { opt: filter.pageDuration, val: DurationOperator } | { opt: filter.referrerUrl, val: UrlOperator } | { opt: filter.region, val: StringOperator } | { opt: filter.sessionEntryPage, val: BoolOperator } | { opt: filter.sessionExitPage, val: BoolOperator } | { opt: filter.text, val: StringOperator } | { opt: filter.timeSincePageLoad, val: DurationOperator } | { opt: filter.timeSinceSessionStart, val: DurationOperator } | { opt: filter.url, val: UrlOperator } | null {
    if (m.url != null) { return { opt: filter.url, val: m.url } }
    if (m.referrerUrl != null) { return { opt: filter.referrerUrl, val: m.referrerUrl } }
    if (m.city != null) { return { opt: filter.city, val: m.city } }
    if (m.region != null) { return { opt: filter.region, val: m.region } }
    if (m.country != null) { return { opt: filter.country, val: m.country } }
    if (m.email != null) { return { opt: filter.email, val: m.email } }
    if (m.name != null) { return { opt: filter.name, val: m.name } }
    if (m.text != null) { return { opt: filter.text, val: m.text } }
    if (m.browser != null) { return { opt: filter.browser, val: m.browser } }
    if (m.pageDuration != null) { return { opt: filter.pageDuration, val: m.pageDuration } }
    if (m.pageActiveDuration != null) { return { opt: filter.pageActiveDuration, val: m.pageActiveDuration } }
    if (m.timeSincePageLoad != null) { return { opt: filter.timeSincePageLoad, val: m.timeSincePageLoad } }
    if (m.timeSinceSessionStart != null) { return { opt: filter.timeSinceSessionStart, val: m.timeSinceSessionStart } }
    if (m.consoleErrorsOnPage != null) { return { opt: filter.consoleErrorsOnPage, val: m.consoleErrorsOnPage } }
    if (m.consoleWarningsOnPage != null) { return { opt: filter.consoleWarningsOnPage, val: m.consoleWarningsOnPage } }
    if (m.displayWidth != null) { return { opt: filter.displayWidth, val: m.displayWidth } }
    if (m.displayHeight != null) { return { opt: filter.displayHeight, val: m.displayHeight } }
    if (m.sessionEntryPage != null) { return { opt: filter.sessionEntryPage, val: m.sessionEntryPage } }
    if (m.sessionExitPage != null) { return { opt: filter.sessionExitPage, val: m.sessionExitPage } }
    return null;
  }
}

/** Maps to the equivalent dependent event fields */
export enum Dimension {
  DIMENSION_UNSET = 0,
  DIMENSION_URL = 1,
  DIMENSION_UTM_CAMPAIGN = 2,
  DIMENSION_REFERRER_URL = 3,
  DIMENSION_CITY = 4,
  DIMENSION_REGION = 5,
  DIMENSION_COUNTRY = 6,
  DIMENSION_EMAIL = 7,
  DIMENSION_NAME = 8,
  DIMENSION_TEXT = 9,
  DIMENSION_BROWSER = 10
}

export interface StringOperator {
  /** element_name maps to the name of a user-defined element. any elements from app context provided should use this field */
  elementName?: string;
  equals?: string;
  notEquals?: string;
  startsWith?: string;
  endsWith?: string;
  containsToken?: string;
  notContainsToken?: string;
  substring?: string;
  css?: string;
  any?: NoneValue | null;
}

export namespace StringOperator {
  export enum operator {
    /** element_name maps to the name of a user-defined element. any elements from app context provided should use this field */
    elementName = 1,
    equals = 2,
    notEquals = 3,
    startsWith = 4,
    endsWith = 5,
    containsToken = 6,
    notContainsToken = 7,
    substring = 8,
    css = 9,
    any = 10
  }

  export function operator_oneof(m: StringOperator): { opt: operator.any, val: NoneValue } | { opt: operator.containsToken, val: string } | { opt: operator.css, val: string } | { opt: operator.elementName, val: string } | { opt: operator.endsWith, val: string } | { opt: operator.equals, val: string } | { opt: operator.notContainsToken, val: string } | { opt: operator.notEquals, val: string } | { opt: operator.startsWith, val: string } | { opt: operator.substring, val: string } | null {
    if (m.elementName != null) { return { opt: operator.elementName, val: m.elementName } }
    if (m.equals != null) { return { opt: operator.equals, val: m.equals } }
    if (m.notEquals != null) { return { opt: operator.notEquals, val: m.notEquals } }
    if (m.startsWith != null) { return { opt: operator.startsWith, val: m.startsWith } }
    if (m.endsWith != null) { return { opt: operator.endsWith, val: m.endsWith } }
    if (m.containsToken != null) { return { opt: operator.containsToken, val: m.containsToken } }
    if (m.notContainsToken != null) { return { opt: operator.notContainsToken, val: m.notContainsToken } }
    if (m.substring != null) { return { opt: operator.substring, val: m.substring } }
    if (m.css != null) { return { opt: operator.css, val: m.css } }
    if (m.any != null) { return { opt: operator.any, val: m.any } }
    return null;
  }
}

export interface DurationOperator {
  atLeast?: protobuf.duration | null;
  atMost?: protobuf.duration | null;
  lessThan?: protobuf.duration | null;
  greaterThan?: protobuf.duration | null;
}

export namespace DurationOperator {
  export enum operator {
    atLeast = 1,
    atMost = 2,
    lessThan = 3,
    greaterThan = 4
  }

  export function operator_oneof(m: DurationOperator): { opt: operator.atLeast, val: protobuf.duration } | { opt: operator.atMost, val: protobuf.duration } | { opt: operator.greaterThan, val: protobuf.duration } | { opt: operator.lessThan, val: protobuf.duration } | null {
    if (m.atLeast != null) { return { opt: operator.atLeast, val: m.atLeast } }
    if (m.atMost != null) { return { opt: operator.atMost, val: m.atMost } }
    if (m.lessThan != null) { return { opt: operator.lessThan, val: m.lessThan } }
    if (m.greaterThan != null) { return { opt: operator.greaterThan, val: m.greaterThan } }
    return null;
  }
}

export interface DateOperator {
  after?: string;
  before?: string;
}

export namespace DateOperator {
  export enum operator {
    after = 1,
    before = 2
  }

  export function operator_oneof(m: DateOperator): { opt: operator.after, val: string } | { opt: operator.before, val: string } | null {
    if (m.after != null) { return { opt: operator.after, val: m.after } }
    if (m.before != null) { return { opt: operator.before, val: m.before } }
    return null;
  }
}

export interface NumericOperator {
  equals?: protobuf.int64;
  notEquals?: protobuf.int64;
  lessThan?: protobuf.int64;
  greaterThan?: protobuf.int64;
  atMost?: protobuf.int64;
  atLeast?: protobuf.int64;
}

export namespace NumericOperator {
  export enum operator {
    equals = 1,
    notEquals = 2,
    lessThan = 3,
    greaterThan = 4,
    atMost = 5,
    atLeast = 6
  }

  export function operator_oneof(m: NumericOperator): { opt: operator.atLeast, val: protobuf.int64 } | { opt: operator.atMost, val: protobuf.int64 } | { opt: operator.equals, val: protobuf.int64 } | { opt: operator.greaterThan, val: protobuf.int64 } | { opt: operator.lessThan, val: protobuf.int64 } | { opt: operator.notEquals, val: protobuf.int64 } | null {
    if (m.equals != null) { return { opt: operator.equals, val: m.equals } }
    if (m.notEquals != null) { return { opt: operator.notEquals, val: m.notEquals } }
    if (m.lessThan != null) { return { opt: operator.lessThan, val: m.lessThan } }
    if (m.greaterThan != null) { return { opt: operator.greaterThan, val: m.greaterThan } }
    if (m.atMost != null) { return { opt: operator.atMost, val: m.atMost } }
    if (m.atLeast != null) { return { opt: operator.atLeast, val: m.atLeast } }
    return null;
  }
}

export interface BoolOperator {
  equals?: boolean;
}

export namespace BoolOperator {
  export enum operator {
    equals = 1
  }

  export function operator_oneof(m: BoolOperator): { opt: operator.equals, val: boolean } | null {
    if (m.equals != null) { return { opt: operator.equals, val: m.equals } }
    return null;
  }
}

export interface BrowserOperator {
  equals?: Browser;
}

export namespace BrowserOperator {
  export enum operator {
    equals = 1
  }

  export function operator_oneof(m: BrowserOperator): { opt: operator.equals, val: Browser } | null {
    if (m.equals != null) { return { opt: operator.equals, val: m.equals } }
    return null;
  }
}

export interface UrlOperator {
  equals?: UrlValue | null;
  notEquals?: UrlValue | null;
  startsWith?: UrlValue | null;
  endsWith?: UrlValue | null;
  substring?: UrlValue | null;
  any?: NoneValue | null;
}

export namespace UrlOperator {
  export enum operator {
    equals = 1,
    notEquals = 2,
    startsWith = 3,
    endsWith = 4,
    substring = 5,
    any = 6
  }

  export function operator_oneof(m: UrlOperator): { opt: operator.any, val: NoneValue } | { opt: operator.endsWith, val: UrlValue } | { opt: operator.equals, val: UrlValue } | { opt: operator.notEquals, val: UrlValue } | { opt: operator.startsWith, val: UrlValue } | { opt: operator.substring, val: UrlValue } | null {
    if (m.equals != null) { return { opt: operator.equals, val: m.equals } }
    if (m.notEquals != null) { return { opt: operator.notEquals, val: m.notEquals } }
    if (m.startsWith != null) { return { opt: operator.startsWith, val: m.startsWith } }
    if (m.endsWith != null) { return { opt: operator.endsWith, val: m.endsWith } }
    if (m.substring != null) { return { opt: operator.substring, val: m.substring } }
    if (m.any != null) { return { opt: operator.any, val: m.any } }
    return null;
  }
}

export interface UrlValue {
  value: string;
  category: UrlCategory;
}

export enum UrlCategory {
  URL_INVALID = 0,
  URL_FULL = 1,
  URL_HOST = 2,
  URL_PATH = 3,
  URL_QUERY = 4,
  URL_FRAGMENT = 5
}

export enum Browser {
  BROWSER_INVALID = 0,
  BROWSER_UNKNOWN = 1,
  BROWSER_CHROME = 2,
  BROWSER_IE = 3,
  BROWSER_EDGE = 4,
  BROWSER_FIREFOX = 5,
  BROWSER_SAFARI = 6,
  BROWSER_MOBILEAPP = 7
}

export interface NoneValue {
}

export interface NoneOperator {
}

export enum Aggregation {
  AGGREGATION_INVALID = 0,
  /** count of events */
  AGGREGATION_EVENT = 1,
  /** count of unique individuals */
  AGGREGATION_INDIVIDUAL = 2,
  /** count of unique sessions */
  AGGREGATION_SESSION = 3
}
